<template>
  <div class="mt-3">
    <h2 class="fw-bold">
      <router-link to="/admin" class="text-teal" title="Área Administrativa">
        Área Administrativa
      </router-link>
      <span class="text-gray">/ Importação</span>
    </h2>
  </div>
  <div class="card border-start border-start-width-3 border-start-teal">
    <div class="card-body">
      <p>
        O arquivo (.xls ou .xlsx) a ser importado deve seguir a estrutura
        abaixo. Os dados devem estar na ordem especificada e os nomes das
        colunas não devem conter acentuação.
      </p>
      <p class="fw-bold mb-1">Legenda:</p>
      <ul>
        <li>
          <strong>codColigada:</strong> Representa o código da coligada |
          <strong>ano:</strong> Representa o ano do orçamento |
          <strong>mes:</strong> Representa o mês do orçamento |
          <strong>periodo:</strong> Representa o tipo de orçamento (1 = PROPOSTO
          | 2 = REFORMULAÇÃO)
        </li>
        <li>
          <strong>codCCustoFilho:</strong> Representa o código do centro de
          custo filho | <strong>codTBOrcamento:</strong> Representa o código da
          natureza orçamentária | <strong>valor:</strong> Representa o valor do
          orçamento
        </li>
      </ul>
      <div class="table-responsive mb-3">
        <table class="table table-sm table-bordered table-striped text-center">
          <thead class="bg-teal text-white">
            <tr>
              <th>codColigada</th>
              <th>ano</th>
              <th>mes</th>
              <th>periodo</th>
              <th>codCCustoFilho</th>
              <th>codTBOrcamento</th>
              <th>valor</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>2025</td>
              <td>1</td>
              <td>1</td>
              <td>1.10.0013</td>
              <td>4.20.001</td>
              <td>32.082,00</td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025</td>
              <td>2</td>
              <td>1</td>
              <td>1.10.0013</td>
              <td>4.20.001</td>
              <td>15.026,00</td>
            </tr>
            <tr>
              <td>1</td>
              <td>2025</td>
              <td>3</td>
              <td>1</td>
              <td>1.10.0013</td>
              <td>4.20.001</td>
              <td>10.000,00</td>
            </tr>
          </tbody>
        </table>
      </div>
      <label class="form-label">Selecione um arquivo</label>
      <div class="input-group">
        <input
          type="file"
          ref="uploadFile"
          class="form-control"
          accept=".xls,.xlsx"
          @change="onFilePicked"
        />
        <button
          type="button"
          class="btn btn-success ms-2"
          title="Importar"
          @click="uploadFile"
        >
          Importar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Importacao',

  data() {
    return {
      file: null,
    }
  },

  methods: {
    onFilePicked(event) {
      const { files } = event.target
      this.file = files.length > 0 ? files[0] : null
    },

    async uploadFile() {
      if (this.file) {
        try {
          const formData = new FormData()
          formData.append('file', this.file)

          const response = await this.$store.dispatch('uploadFile', formData)

          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }

        this.file = null
        this.$refs.uploadFile.value = null
      } else {
        this.$root.$refs.notification.warning('Selecione um arquivo.')
      }
    },
  },
}
</script>
